import {
    Bell,
    UserPlus,
    Ticket,
    BadgeCheck,
    UserRound,
    UserCog,
} from "lucide-react";

const getIconConfig = (
    notification
) => {
    const type =
        notification.notification_type;

    const iconMap = {
        "Driver Partner Referral Milestone":
            Bell,

        "Driver Registered":
            UserPlus,

        "Customer Support":
            Ticket,

        "Driver Partner Approved":
            BadgeCheck,

        "User Profile Incomplete":
            UserCog,

        "User Profile Created":
            UserRound,
    };

    return {
        icon:
            iconMap[type] ||
            Bell,
        color:
            "#2453FF",
        bg:
            "#EEF4FF",
    };
};

export default getIconConfig;